import axios from "axios";

export default function getPrifeReceiveTransferSenderDropdown(params) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/prife/transfer/get-sender-dropdown`, {
        params,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
